'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = createModel;

var _ramda = require('ramda');

var _modula = require('modula');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PredefinedSpecKeys = ['actionTypes', 'propTypes', 'defaults', 'contextTypes', 'childContextTypes', 'services', 'delegates', 'displayName'];

function getPredefinedSpec(spec) {
  return (0, _ramda.pick)(PredefinedSpecKeys, spec);
}

function getCustomSpec(spec) {
  return (0, _ramda.omit)(PredefinedSpecKeys, spec);
}

function replaceValues(comment, types) {
  return (0, _ramda.reduce)(function (memo, key) {
    return (0, _ramda.merge)(memo, _defineProperty({}, key, comment));
  }, {}, (0, _ramda.keys)(types));
}

function checkCompatibility(spec) {
  if (spec.eventTypes || spec.watchEventTypes) {
    throw new Error('model event support has been removed, please utilize modelDidUpdate instead');
  }

  if (spec.localProps || spec.localPropTypes) {
    throw new Error('model local props support has been removed, please move props back to propTypes instead, and remove connectLocal from component side');
  }

  if (spec.defaults && (0, _ramda.is)(Function, spec.defaults)) {
    throw new Error('model support for "defaults" value is a function has been removed, please move the function to each attribute of defaults');
  }

  // TODO check contextTypes and childContextTypes
  // should all be PropTypes.func or PropTypes.func.isRequired
  // throw error if found other types

  (0, _ramda.forEach)(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (!(0, _ramda.is)(Function, value)) {
      throw new Error('"' + key + '" provided in createModel is not a function; for non-predefined spec keys model will assume all of their values are function now');
    }
  }, (0, _ramda.toPairs)(getCustomSpec(spec)));
}

function createModel(spec) {
  if (process.env !== 'production') {
    checkCompatibility(spec);
  }

  var systemSpec = getPredefinedSpec(spec);
  var customSpec = getCustomSpec(spec);

  var BusinessModel = function (_Model) {
    _inherits(BusinessModel, _Model);

    function BusinessModel() {
      _classCallCheck(this, BusinessModel);

      return _possibleConstructorReturn(this, (BusinessModel.__proto__ || Object.getPrototypeOf(BusinessModel)).apply(this, arguments));
    }

    return BusinessModel;
  }(_modula.Model);

  (0, _ramda.forEach)(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    BusinessModel.prototype[key] = value;
  }, (0, _ramda.toPairs)(customSpec));

  if (systemSpec.actionTypes) {
    BusinessModel.actionTypes = systemSpec.actionTypes;
  }

  if (systemSpec.contextTypes) {
    // we assume all context types are functions now
    // and the value becomes a text description about
    // what we provide/consume the context
    BusinessModel.contextTypes = replaceValues(null, systemSpec.contextTypes);
  }

  if (systemSpec.childContextTypes) {
    BusinessModel.childContextTypes = replaceValues('Migrated from legacy child context types', systemSpec.childContextTypes);
  }

  if (systemSpec.propTypes) {
    BusinessModel.propTypes = systemSpec.propTypes;
  }

  if (systemSpec.defaults) {
    BusinessModel.defaultProps = systemSpec.defaults;
  }

  if (systemSpec.services) {
    BusinessModel.services = systemSpec.services;
  }

  if (systemSpec.delegates) {
    BusinessModel.delegates = systemSpec.delegates;
  }

  if (systemSpec.displayName) {
    BusinessModel.displayName = systemSpec.displayName;
  }

  return BusinessModel;
}